//
// CommonsPackage.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "./moduleBuilder";
import ClosetObject from "./ClosetObject";
import "./PortablePackage";

var CommonsPackage = createModule("commons::CommonsPackage", ["commons::PortablePackage"], ClosetObject, [
    ,
    ,
    ,
    ,
    ,
    {
        FEATURE_CLIENT_NETWORK_DATA_DEBUG: [7],
        instance: [1],
    },
    ,
]);
export default CommonsPackage;
